import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faHome } from '@fortawesome/free-solid-svg-icons';

const Unauthorized = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full mx-auto text-center p-8">
        <FontAwesomeIcon 
          icon={faLock} 
          className="text-red-500 text-5xl mb-4" 
        />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Access Denied
        </h1>
        <p className="text-gray-600 mb-6">
          You don't have permission to access this page. Please contact your administrator if you believe this is a mistake.
        </p>
        <div className="space-x-4">
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
          >
            <FontAwesomeIcon icon={faHome} className="mr-2" />
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized; 